import commonHelper from '@/app/utility/common.helper.utility';
import appStrings from '@/app/utility/string.utility';
import isdDistributionDetails from './isdDistributionDetails';
import isdDistributionInvoice from './isdDistributionInvoice';
export default {
  name: 'isdDistribution',
  watch: {
    currentPage: function() {
      this.getIsdHeaderData();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getIsdHeaderData();
    }
  },
  components: { isdDistributionDetails, isdDistributionInvoice },
  data() {
    return {
      loader: false,
      vsetCode: null,
      showValueSetModal: false,
      parent_value_set_id: null,
      depVsetParam: null,
      currentPage: 1,
      totalRows: null,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOption(),
      financialYear: {
        text: null,
        value: null
      },
      gstn: {
        text: null,
        value: null
      },
      period: {
        text: null,
        value: null
      },
      legalEntity: {
        text: null,
        value: null
      },
      isdHeaderData: [],
      isdHeaderFields: [
        {
          key: 'DistFreezeFlag',
          label: 'Freeze',
          class: 'text-center'
        },
        {
          key: 'FinYear',
          label: 'Financial Year',
          class: 'text-center'
        },
        {
          key: 'OrgName',
          label: 'Legal Entity',
          class: 'text-center'
        },
        {
          key: 'DistPeriodName',
          label: 'Filing Period',
          class: 'text-center'
        },
        {
          key: 'ReturnPeriod',
          label: 'Return Period',
          class: 'text-center'
        },
        {
          key: 'IsdGstn',
          label: 'GSTN',
          class: 'text-center'
        }
      ],
      showIsdDistributionDeatilModal: false,
      accessButtons: {
        deleteAllow: false,
        downloadAllow: false,
        uploadAllow: false,
        editAllow: true,
        addAllow: true,
        printAllow: false,
        approvalAllow: false
      },
      rowData: null,
      AggHdrId: null,
      editMode: false,
      isdDistributionInvoiceModal: false,
      freezeFlag: false,
      modalType: null
    };
  },
  mounted() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (
          actionName === 'save' &&
          !this.showIsdDistributionDeatilModal &&
          !this.isdDistributionInvoiceModal
        ) {
          this.postfreezeIsdData();
        }
        if (actionName === 'update') {
          this.editMode = true;
        }
      }
    });
  },
  methods: {
    openValueSetModal(vsetCode) {
      this.vsetCode = vsetCode;
      this.showValueSetModal = true;
      this.parent_value_set_id = null;
      this.depVsetParam = null;
      if (this.vsetCode === appStrings.VALUESETTYPE.ISD_GL_PERIOD) {
        this.parent_value_set_id = this.legalEntity.value;
        this.depVsetParam = this.financialYear.value;
      } else if (this.vsetCode === appStrings.VALUESETTYPE.GST_ISD_GSTN) {
        this.parent_value_set_id = null;
      }
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    selectedvalueSet(item) {
      if (this.vsetCode === appStrings.VALUESETTYPE.CUSTOM_FY) {
        this.financialYear = {
          text: item.value_code,
          value: item.value_code
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.GST_ISD_GSTN) {
        this.gstn = {
          text: item.value_code,
          value: item.value_code
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.LEGAL_ENTITY_LIST) {
        this.legalEntity = {
          text: item.org_name,
          value: item.value_set_dtl_id
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.ISD_GL_PERIOD) {
        this.period = {
          text: item.period_name,
          value: item.value_code
        };
      }
    },
    clearVsetValues(vsetCode) {
      this.parent_value_set_id = null;
      if (vsetCode === 'CUSTOM_FY') {
        this.financialYear = {
          text: null,
          value: null
        };
      } else if (vsetCode === 'GST_ISD_GSTN') {
        this.gstn = {
          text: null,
          value: null
        };
      } else if (vsetCode === 'LEGAL_ENTITY_LIST') {
        this.legalEntity = {
          text: null,
          value: null
        };
      } else if (vsetCode === 'ISD_GL_PERIOD ') {
        this.period = {
          text: null,
          value: null
        };
      }
    },
    clearFilters() {
      this.financialYear = {
        text: null,
        value: null
      };
      this.gstn = {
        text: null,
        value: null
      };
      this.period = {
        text: null,
        value: null
      };
      this.legalEntity = {
        text: null,
        value: null
      };
      this.isdHeaderData = [];
    },
    showHideIsdDistributionDetailsModal(flag) {
      this.showIsdDistributionDetailsModal = flag;
    },
    getIsdAllData() {
      if (
        !this.legalEntity.value ||
        !this.financialYear.value ||
        !this.period.value
      ) {
        this.$bvToast.toast('Please Select Mandatory Fields', {
          title: 'Alert',
          variant: 'danger',
          solid: true
        });
      } else {
        this.getIsdHeaderData();
      }
    },
    rowSelected(item) {
      this.rowData = item;
      this.showIsdDistributionDeatilModal = true;
    },
    showHideIsdDistributionModal(flag) {
      this.showIsdDistributionDeatilModal = flag;
    },
    showHideIsdDistributionInvoiceModal(flag) {
      this.isdDistributionInvoiceModal = flag;
      this.modalType = null;
    },
    getIsdHeaderData() {
      const payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        le_id: this.legalEntity.value,
        fp_gst: this.gstn.value,
        dist_period: this.period.value,
        fin_year: this.financialYear.value
      };
      this.loader = true;
      this.$store
        .dispatch('isdRevenue/getIsdHeaderData', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.editMode = true;
            this.isdHeaderData = response.data.data.page;
            this.totalRows = response.data.data.total_elements;
            this.freezeFlag =
              this.isdHeaderData[0].DistFreezeFlag === 'Y' ? true : false;
            this.isdHeaderData.map(data => {
              data.DistFreezeFlag = data.DistFreezeFlag === 'Y' ? true : false;
              return data;
            });
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    freezeData() {
      this.aggHdrId = this.isdHeaderData.map(item => {
        return {
          agg_hdr_id: item.AggHdrId
        };
      });
    },
    postfreezeIsdData() {
      const payload = {
        params: this.aggHdrId
      };

      this.loader = true;
      this.$store
        .dispatch('isdRevenue/postfreezeIsdData', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.$bvToast.toast(response.data.message, {
              title: 'Alert',
              variant: 'success',
              solid: true
            });
            this.getIsdHeaderData();
          }
        });
    },
    openViewInvoiceModal(type) {
      this.modalType = type;
      if (
        !this.legalEntity.value ||
        !this.financialYear.value ||
        !this.period.value
      ) {
        this.isdDistributionInvoiceModal = false;
        this.$bvToast.toast('Please Select Mandatory Fields ', {
          title: 'Alert',
          variant: 'danger',
          solid: true
        });
      } else {
        this.isdDistributionInvoiceModal = true;
      }
    }
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
